import { SelectOptionUi } from '@/components/Select/SelectUi';

export type AssignKamDialogUi = {
  kamList: SelectOptionUi[];
  selectedKamId: string;
};

export const initialState: AssignKamDialogUi = {
  kamList: [],
  selectedKamId: '',
};
